import { useMemo, ReactNode } from "react";

import { useGetNotifications } from "@hooks/useGetNotifications";
import { NotificationsContext } from "@contexts/NotificationsContext";
import { languageEnglish } from "../i18n";
import { useCurrentLang } from "@hooks/useCurrentLang";

interface UserProviderProps {
  children: ReactNode;
}

export const NotificationsProvider: React.FC<UserProviderProps> = ({
  children,
}: UserProviderProps) => {
  const currentLang = useCurrentLang();

  const { data: notificationsData = [] } = useGetNotifications({
    language: currentLang === languageEnglish ? languageEnglish : undefined,
  });

  const value = useMemo(() => {
    return {
      notifications: notificationsData.filter(
        (notification) => !notification.isDeleted
      ),
      hasUnreadNotifications: notificationsData.some(
        (notification) => !notification.isRead
      ),
    };
  }, [notificationsData]);

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
};
